import type { SlashMenuTooltip } from '../types';
import { CopyTooltip } from './copy';
import { DeleteTooltip } from './delete';
import { MoveDownTooltip } from './move-down';
import { MoveUpTooltip } from './move-up';
import { NowTooltip } from './now';
import { TodayTooltip } from './today';
import { TomorrowTooltip } from './tomorrow';
import { YesterdayTooltip } from './yesterday';

export const slashMenuToolTips: Record<string, SlashMenuTooltip> = {
  Today: {
    figure: TodayTooltip,
    caption: 'Hoje',
  },

  Tomorrow: {
    figure: TomorrowTooltip,
    caption: 'Amanhã',
  },

  Yesterday: {
    figure: YesterdayTooltip,
    caption: 'Ontem',
  },

  Now: {
    figure: NowTooltip,
    caption: 'Agora',
  },

  'Move Up': {
    figure: MoveUpTooltip,
    caption: 'Mover para cima',
  },

  'Move Down': {
    figure: MoveDownTooltip,
    caption: 'Mover para baixo',
  },

  Copy: {
    figure: CopyTooltip,
    caption: 'Copiar / Duplicar',
  },

  Delete: {
    figure: DeleteTooltip,
    caption: 'Excluir',
  },
};
